var _path, _line, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorFlorist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.677,11.736c0-2.293-1.859-4.151-4.151-4.151-.68,0-1.32.167-1.886.457.049-.256.077-.519.077-.79,0-2.293-1.859-4.151-4.151-4.151-2.293,0-4.151,1.859-4.151,4.151,0,.26.027.514.073.76-.552-.271-1.17-.427-1.826-.427-2.293,0-4.151,1.859-4.151,4.151,0,2.025,1.451,3.709,3.369,4.075-.676.738-1.092,1.719-1.092,2.799,0,2.293,1.859,4.151,4.151,4.151,1.592,0,2.973-.897,3.669-2.212.697,1.315,2.077,2.212,3.669,2.212,2.293,0,4.151-1.859,4.151-4.151,0-1.082-.417-2.064-1.095-2.803,1.906-.376,3.345-2.055,3.345-4.072Zm-10.112,4.368c-1.52,0-2.752-1.232-2.752-2.752s1.232-2.752,2.752-2.752,2.752,1.232,2.752,2.752-1.232,2.752-2.752,2.752Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20.594,
    y1: 38.9,
    x2: 20.594,
    y2: 20.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.603,34.436l10.662-8.757s1.295,3.764-2.327,7.386c-3.623,3.623-8.334,1.371-8.334,1.371Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.837,23.927l8.757,10.662s-3.764,1.295-7.386-2.327c-3.623-3.623-1.371-8.334-1.371-8.334Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorFlorist);
export default __webpack_public_path__ + "static/media/indoor-florist.84caf9ea3f2aaa8bec2f1b82d99164db.svg";
export { ForwardRef as ReactComponent };